class Product {
    private gallery: HTMLElement | null;
    private wrappers: NodeListOf<HTMLElement> | null;

    constructor(private product: HTMLElement) {
        this.gallery = this.product.querySelector<HTMLElement>('.woocommerce-product-gallery');
        this.wrappers = this.gallery?.querySelectorAll<HTMLElement>('.woocommerce-product-gallery__image > a');

        this.init();
    }

    init() {
        this.images();
    }

    private images() {
        this.wrappers?.forEach((wrapper, index) => {
            const image = wrapper.querySelector<HTMLImageElement>('img');
            let wrapperWidth: string;
            let wrapperHeight: string;

            if (wrapper.hasAttribute('data-iframe')) {
                wrapperWidth = '1920';
                wrapperHeight = '1080';
            } else if (image) {
                const widthAttr = image.getAttribute('width');
                const heightAttr = image.getAttribute('height');

                wrapperWidth = widthAttr ?? image.naturalWidth.toString();
                wrapperHeight = heightAttr ?? image.naturalHeight.toString();
            }

            wrapper.setAttribute('data-cropped', 'true');
            wrapper.setAttribute('data-pswp-width', wrapperWidth);
            wrapper.setAttribute('data-pswp-height', wrapperHeight);

            if (index === 5 && this.wrappers?.length > 6) {
                const moreCount = this.wrappers.length - 6;
                wrapper.setAttribute('data-image-count', `+${moreCount}`);
            }
        });
    }
}

window.addEventListener('load', () => {
    const product = document.querySelector<HTMLElement>('.woocommerce-product');

    if (product) {
        new Product(product);
    }
});